/* eslint-disable */
import libraries from "../arduino/libraries";

export default function init(Blockly, profile) {
  Blockly.Arduino.infrared = {};

  Blockly.Arduino.infrared_irrx_multi = function () {
    var pin = this.getFieldValue("PIN");
    Blockly.Arduino.includes_.push(libraries.ir_remote);
    Blockly.Arduino.definitions_.define_irremote = '#include "IRremote.h"';
    Blockly.Arduino.definitions_fnc_.fnc_ir_rx_multi =
      `String fnc_ir_rx_multi() {\n` +
      `  char buff[16];\n` +
      `  buff[0] = 0;\n` +
      `  if(IrReceiver.decode()) {\n` +
      `    sprintf(buff, "%08lX", (unsigned long)IrReceiver.decodedIRData.decodedRawData);\n` +
      `    IrReceiver.resume();\n` +
      `  }\n` +
      `  return String(buff);\n` +
      `}\n`;
    Blockly.Arduino.setups_.setup_ir_rx = "  IrReceiver.begin(" + pin + ");\n";
    return ["fnc_ir_rx_multi()", Blockly.Arduino.ORDER_ATOMIC];
  };

  Blockly.Arduino.infrared_irtx_multi = function () {
    let pin = this.getFieldValue("PIN");
    let protocol = this.getFieldValue("PROTOCOL");
    let ir_code = Blockly.Arduino.valueToCode(
      this,
      "CODE",
      Blockly.Arduino.ORDER_ATOMIC
    );
    let bits = Blockly.Arduino.valueToCode(
      this,
      "BITS",
      Blockly.Arduino.ORDER_ATOMIC
    );
    let code = "";

    Blockly.Arduino.includes_.push(libraries.ir_remote);
    Blockly.Arduino.definitions_.define_irremote = '#include "IRremote.h"';
    Blockly.Arduino.setups_.setup_ir_tx =  "  IrSender.begin(" + pin + ", false);\n";

    "RC5"     == protocol && (code = "IrSender.sendRC5(");
    "RC6"     == protocol && (code = "IrSender.sendRC6(");
    "NEC"     == protocol && (code = "IrSender.sendNEC(");
    "SONY"    == protocol && (code = "IrSender.sendSony(");
    "JVC"     == protocol && (code = "IrSender.sendJVC(");
    "SAMSUNG" == protocol && (code = "IrSender.sendSAMSUNG(");
    "WHYNTER" == protocol && (code = "IrSender.sendWhynter(");
    "AIWA"    == protocol && (code = "IrSender.sendAiwaRCT501(");
    "LG"      == protocol && (code = "IrSender.sendLG(");
    "DISH"    == protocol && (code = "IrSender.sendDISH(");
    "DENON"   == protocol && (code = "IrSender.sendDenon(");

    code += "(unsigned long)" + ir_code;

    code += "JVC" == protocol     ?
            ", " + bits + ", 1);\n" :
            "AIWA" == protocol    ? 
            ");\n"                : 
            ", " + bits + ");\n";

    return code;
  };

  Blockly.Arduino.infrared_irrx_number = function () {
    let pin = this.getFieldValue("PIN");

    Blockly.Arduino.includes_.push(libraries.ir_remote);
    Blockly.Arduino.definitions_.define_irremote = '#include "IRremote.h"';
    Blockly.Arduino.definitions_fnc_.fnc_ir_rx_number =
      "uint32_t fnc_ir_rx_number() {\n" +
      "  uint32_t data = 0;\n" +
      "  if (IrReceiver.decode()) {\n" +
      "    data = IrReceiver.decodedIRData.decodedRawData;\n" +
      "    IrReceiver.resume();\n" +
      "  }\n" +
      "  return data;\n" +
      "}\n";
    Blockly.Arduino.setups_.setup_ir_rx = "  IrReceiver.begin(" + pin + ");\n";
    return ["fnc_ir_rx_number()", Blockly.Arduino.ORDER_ATOMIC];
  };

  Blockly.Arduino.infrared_irtx_number = function () {
    let pin = this.getFieldValue("PIN");
    let ir_code = Blockly.Arduino.valueToCode(
      this,
      "DATA",
      Blockly.Arduino.ORDER_ATOMIC
    );
    let code = "";

    Blockly.Arduino.includes_.push(libraries.ir_remote);
    Blockly.Arduino.definitions_.define_irremote = '#include "IRremote.h"';
    Blockly.Arduino.setups_.setup_ir_tx =  "  IrSender.begin(" + pin + ", false);\n";

    code = "IrSender.sendNECRaw((uint32_t)" + ir_code + ", 2);\n";
    return code;
  };

}
